import { useEffect, useState } from "react";
import { safeUrl } from "../utils/appData";
import { displayName } from "../utils/discoverData";
export default function UserAvatar({
  user,
  className = "h-12 w-12 shrink-0 rounded-full object-cover",
}) {
  const [failed, setFailed] = useState(false);
  const url = safeUrl(user?.profilePic || user?.photoURL || user?.avatarUrl);
  useEffect(() => setFailed(false), [url]);
  return url && !failed ? (
    <img
      className={className}
      src={url}
      alt=""
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  ) : (
    <span
      className={`${className} grid place-items-center bg-gradient-to-br from-[#5e9bb2] to-[#24596e] font-bold text-white`}
      aria-hidden="true"
    >
      {displayName(user).slice(0, 1).toUpperCase()}
    </span>
  );
}
